import { call, put } from 'redux-saga/effects';

import generateQuery from 'utils/generateQuery';

import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';
import { MESSAGES } from 'appconstants';

import {
  SERVICERATE,
  LOADING,
  NOTIFICATION,
} from '../actionTypes';

const fetchServicerates = async (payload) => {
  const query = generateQuery(payload.currentPage);
  const sorting = payload.sortParams ? payload.sortParams : '&sortBy=createdAt&direction=DESC';
  if (payload.pageSize) {
    return axiosAuthInstance.get(`${API_END_POINTS.SERVICEFEE}?${payload.pageSize}${sorting}`);
  }
  if (payload.filterParams && !payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.SERVICEFEE}?${payload.filterParams}`);
  }
  if (payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.SERVICEFEE}${query}${sorting}&${payload.filterParams}`);
  }
  if (!payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.SERVICEFEE}${query}${sorting}`);
  }
  return axiosAuthInstance.get(`${API_END_POINTS.SERVICEFEE}${query}${sorting}`);
};

const postCustomer = async ({ params }) => axiosAuthInstance.post(API_END_POINTS.SERVICEFEE, params);

const patchCustomer = async ({ gid, params }) => axiosAuthInstance.patch(`${API_END_POINTS.SERVICEFEE}/${gid}`, params);

const deleteCustomer = async ({ gid }) => axiosAuthInstance.delete(`${API_END_POINTS.SERVICEFEE}/${gid}`);

export function* getServicerates(action) {
  try {
    const { data: { entity } } = yield call(fetchServicerates, action.payload);
    yield put({ type: SERVICERATE.SUCCESS, payload: entity });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
    yield put({ type: SERVICERATE.FAILED, payload: e.response.data });
  }
}

export function* addServicerate(action) {
  try {
    yield put({ type: LOADING.SUBMITTING });
    yield put({ type: LOADING.VALIDATING });
    yield call(postCustomer, action.payload);
    const { data: { entity } } = yield call(fetchServicerates, action.payload);
    yield put({ type: SERVICERATE.SUCCESS, payload: entity });
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: MESSAGES.SERVICERATE.ADD_SUCCESS,
    });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
  }
}

export function* deleteServicerate(action) {
  try {
    yield put({ type: LOADING.VALIDATING });
    yield put({ type: LOADING.SUBMITTING });
    yield call(deleteCustomer, action.payload);
    const { data: { entity } } = yield call(fetchServicerates, action.payload);
    yield put({ type: SERVICERATE.SUCCESS, payload: entity });
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: MESSAGES.SERVICERATE.DELETE_SUCCESS,
    });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
  }
}

export function* updateServicerate(action) {
  try {
    yield put({ type: LOADING.SUBMITTING });
    yield put({ type: LOADING.VALIDATING });
    yield call(patchCustomer, action.payload);
    const { data: { entity } } = yield call(fetchServicerates, action.payload);
    yield put({ type: SERVICERATE.SUCCESS, payload: entity });
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: 'Service rate updated successfully',
    });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
  }
}
